import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Authorization, Documento } from "../models/data.model";
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class CommonService<T> {

  private BASE_URL: string;
  private BASE_URL_ARCADOC : string;
  private principal: Authorization;


  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.BASE_URL = baseUrl;
  }

  public SetBaseUrl(baseUrl: string) {
    this.BASE_URL = baseUrl;
  }

  public SetBaseUrlArcaDoc(baseUrl: string) {
    this.BASE_URL_ARCADOC = baseUrl;
  }

  public getData(url: string, params: any, ignore: boolean): Observable<T | T[]> {
    if(ignore) params.headers = { ignoreLoadingBar: '' };
    return this.http.get(this.BASE_URL + url, params).pipe(map((data: T | T[]) => data));
  }

  public getOpenIDToken(url: string): Observable<T | T[]> {
    return this.http.get(this.BASE_URL + url).pipe(map((data: T | T[]) => data));
  }

  openIdLogin() {
    var url = environment.openIdUrl + '?ApplicationName=' + environment.applicationEnum
    window.location.href = url
  }

  public postData(url: string, input: any, ignore: boolean): Observable<T|T[]> {
    if(ignore) input.headers = { ignoreLoadingBar: '' };


    return this.http.post(this.BASE_URL + url, input).pipe(map((data: T | T[]) => data));
  }

  public postDataHeader(url, input, ignore, headers): Observable<T | T[]> {
    if (ignore) input.headers = { ignoreLoadingBar: '' };

    console.log("richiamo la url", this.BASE_URL,  url)
    return this.http.post(this.BASE_URL + url, input, headers).pipe(map((data: T | T[]) => data));
  }

  public postAuthArcadoc(url, input, ignore): Observable<T|T[]> {
    if(ignore) input.headers = { ignoreLoadingBar: '' };


    return this.http.post(this.BASE_URL_ARCADOC + url, input).pipe(map((data: T | T[]) => data));
  }

  public postDataArcadoc(url, input, token): Observable<T|T[]>
  {
    this.BASE_URL_ARCADOC = 'http://localhost:7983/'
    var headers_object = new HttpHeaders().set("Authorization", "Bearer " + token);
    const httpOptions = {
      headers: headers_object
    };

    return this.http.post(this.BASE_URL_ARCADOC + url, input, httpOptions).pipe(map((data: T | T[]) => data));
  }

  public getDataArcadoc(url, input, token): Observable<T|T[]>
  {
    var headers_object = new HttpHeaders().set("Authorization", "Bearer " + token);
    const httpOptions =
    {
      headers: headers_object,
      params: input
    };

    return this.http.get(this.BASE_URL_ARCADOC + url, httpOptions).pipe(map((data: T | T[]) => data));
  }

  public getPrincipal(): Authorization {
    if (this.principal == null)

      this.getData("api/auth/getPrincipal", {}, false).subscribe(result => {
        console.log("result", result);
        if (result != null) {
          console.log(result);
          this.setPrincipal(result[0] as Authorization);
        }
     }, error => console.error(error));

     return this.principal;
  }


  public getPrincipalNew(): Observable<T | T[]>
  {
      return this.getData("api/auth/getPrincipal", {}, false);
  }


  public async getPrincipalAsync(): Promise<any> {
    const authresult = this.getData("api/auth/getPrincipal", {}, false).toPromise();
    return authresult;
  }

  public setPrincipal(_principal: Authorization): Authorization {
    return this.principal = _principal;
  }

  // Determina se almeno una delle legal entities a cui il documento è associato è 'Compliance'
  public isLegalEntityComplianceAssociated(document: Documento): boolean {
    const legalEntities = this.getDocumentMetadataValue(document, 'LegalEntities');
    return legalEntities.split('/').some(legalEntity => legalEntity.trim().toLowerCase() === 'compliance');
  }

  public getDocumentMetadataValue(document: Documento, key: string): string {
    if (!document || !document.metadatiDtoList) {
      return '';
    }

    const metadata = document.metadatiDtoList.find(item => item && item.key && item.key.toLowerCase() === key.toLowerCase());
    return metadata && metadata.value ? metadata.value : '';
  }

  public isLoggedIn(): Boolean {
    console.log(this.principal);

    //if (this.getPrincipal() != null)
      return true;

    //return false;
  }
}
